import { Component, forwardRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-form-input-number',
  standalone: false,
  templateUrl: './form-input-number.component.html',
  styleUrl: './form-input-number.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputNumberComponent),
      multi: true
    }
  ]
})
export class FormInputNumberComponent implements OnInit, ControlValueAccessor {
  @Input() decimals: number = 2;
  @Input() disabled: boolean;
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() info: string;
  @Input() label: string;
  @Input() noLabel: boolean;

  public id: string;

  public onChange = (_: any) => {
  };
  public onTouch = () => {
  };

  constructor() {
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
  }

  // value accessor functions
  writeValue(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    this.onTouch();
    this.onChange($event);
  }
}
